export const CARDS_LIST_FETCH = 'timewreck/cardsList/FETCH';
export const CARDS_LIST_FETCH_SUCCESS = 'timewreck/cardsList/FETCH.SUCCESS';
export const CARDS_LIST_FETCH_FAILURE = 'timewreck/cardsList/FETCH.FAILURE';